import React, {useRef, useState} from 'react';
import {Link, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import Search from "../../Search/Search";
import LanguageDropdown from "../../LanguageDropdown/LanguageDropdown";
import SvgSelector from "../../SvgSelector/SvgSelector";
import NotificationsPopup from "../../UiKit/Popups/NotificationsPopup/NotificationsPopup";
import {globalDataSelector, setAdaptiveMenu, setIsNotificationPopupActive} from "../../../redux/slices/globalDataSlice";
import {managementSelector} from "../../../redux/slices/managementSlice";
import {setTopUpBalanceActive} from "../../../redux/slices/financeSlice";
import {is_tech_user, user_role} from "../../../storage/user";
import s from './header.module.scss'
import {subscriptionSelector} from "../../../redux/slices/subscriptionSlice";
import subscriptionsDisabledRedBG from '../../../assets/img/subscriptionsDisabledRedBG.png'
import {useTranslation} from "react-i18next";
import {convertDate, getDaysDifference} from "../../../utils/helpers/formatTime";
import {subscriptionLimits} from "../../../pages/Authorized/SpecialAccess/Subscriptions/Subscriptions";
import {authSelector} from "../../../redux/slices/authSlice";
import {OWNER, teamsHighLevelAccess} from "../../../utils/vars/staticVariables";
import {calculateTimeDifferenceFromNow} from "../../../utils/helpers/calculateTimeDifferenceFromNow";
import {getDaysLabel, getHoursLabel, getMinutesLabel} from "../../../utils/helpers/getDateFieldLabel";
import {getLanguage} from "../../../storage/switchLanguage";
// import {teamsHighLevelAccess} from "../../../pages/Authorized/Teams/Teams";

const Header = ({
                    isSearch = false,
                    searchValue,
                    setSearchValue,
                    isCreateButton = false,
                    isButton = false,
                    isLink = false,
                    linkPath,
                    buttonText,
                    buttonHandler,
                    isButtonPending
                }) => {
    const notificationsBtnRef = useRef(null);
    const [isSubscriptionToolipActive, setSubscriptionTooltipActive] = useState(false);
    const dispatch = useDispatch();
    const {areHiddenFinancialOperations} = useSelector(authSelector);
    const {
        isAdaptiveMenuActive,
        isNotificationPopupActive,
        hasUnreadNotifications,
        isCollapsedSidebar
    } = useSelector(globalDataSelector);

    const {subscriptionsList, fetchSubscriptionsPending, isInitialInstallsLimits} = useSelector(subscriptionSelector);

    const {t} = useTranslation();

    const navigate = useNavigate()

    // const currentSubscription = subscriptionsList.find(item => item?.is_active === true && item?.active_by_time === true)
    const currentSubscription = subscriptionsList.find(item => item?.is_active === true && item?.active_by_time === true)

    const {
        name: subscriptionName,
        end_date_count: subscriptionEndDateCount,
        start_date: subscriptionStartDate,
        end_date: subscriptionEndDate,
        bgImage: subscriptionBgImage
    } = currentSubscription || {}


    const {
        days: subscriptionDaysLeft,
        hours: subscriptionHoursLeft,
        minutes: subscriptionMinutesLeft
    } = calculateTimeDifferenceFromNow(subscriptionEndDate)

    // const subscriptionDaysLeft = 0
    // const subscriptionHoursLeft = 0
    // const subscriptionMinutesLeft = 31

    return (
        <div
            className={`${s.pageHeaderWrapper} ${isCollapsedSidebar === "true" ? s.collapsedSidebar : ""}`}
        >
            <NotificationsPopup bellButtonRef={notificationsBtnRef}/>
            <div className={s.pageHeaderContainer}>
                <div className={s.staticElements}>
                    <div className={s.leftSideWrapper}>

                        {
                            !areHiddenFinancialOperations && <button
                                className={s.walletBtn}
                                onClick={() => {
                                    dispatch(setAdaptiveMenu(false));
                                    dispatch(setTopUpBalanceActive(true));
                                }}
                            >
                                <SvgSelector id="wallet"/>
                            </button>
                        }
                        <Link className={s.walletBtn} to="/account">
                            <SvgSelector id="account-gear-icon"/>
                        </Link>
                        <button
                            className={s.notificationsBtn}
                            onClick={() => {
                                dispatch(setIsNotificationPopupActive(!isNotificationPopupActive))
                            }}
                            ref={notificationsBtnRef}
                        >
                            <div className={s.bellWrapper}>
                                <SvgSelector id="notifications-bell-icon"/>
                            </div>
                            {
                                hasUnreadNotifications && <span className={s.circle}></span>
                            }
                        </button>
                        <LanguageDropdown/>
                    </div>

                    <div className={s.menuBtnContainer}>

                        {
                            !is_tech_user && <div className={s.subscriptionContainer}>
                                <ul
                                    className={`
                                    ${s.limitsInfoList}
                                    ${isSearch && !isButton && !isLink ? s.search : ''}
                                    ${isSearch && (isButton || isLink) ? s.searchButton : ''}
                                    ${!isSearch && !isButton && !isLink ? s.empty : ''}
                                `}>
                                    {subscriptionLimits.map(({iconId, defaultKey, subscriptionKey}) => (
                                        <li key={iconId}>
                                            <SvgSelector id={iconId}/>
                                            <span>
                                          {fetchSubscriptionsPending
                                              ? "---"
                                              : !isInitialInstallsLimits
                                                  ? currentSubscription?.[defaultKey] === undefined
                                                      ? "---"
                                                      : currentSubscription?.[defaultKey] === null
                                                          ? <SvgSelector id='all-in-icon'/>
                                                          : currentSubscription?.[defaultKey]
                                                  : currentSubscription?.[subscriptionKey] === undefined
                                                      ? "---"
                                                      : currentSubscription?.[subscriptionKey] === null
                                                          ? <SvgSelector id='all-in-icon'/>
                                                          : currentSubscription?.[subscriptionKey]}
                                        </span>
                                        </li>
                                    ))}

                                </ul>


                                {
                                    currentSubscription && <div className={s.subscriptionEndingInfoContainer}>
                                        <SvgSelector id='subscriptions-icon'/>
                                        <div className={s.timeDetails}>
                                            <span className={s.subscriptionExpiration}>{t('subscription_expiration')}:</span>

                                            {
                                                subscriptionDaysLeft < 1 && subscriptionHoursLeft < 1 ?
                                                    <span className={s.timeInfo}>
                                                        {getMinutesLabel(subscriptionMinutesLeft, getLanguage())}{" "}
                                                    </span>
                                                    :
                                                    <span className={s.timeInfo}>
                                                        {getDaysLabel(subscriptionDaysLeft, getLanguage())}{" "}
                                                        {getHoursLabel(subscriptionHoursLeft, getLanguage())}{" "}
                                                    </span>
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    isSubscriptionToolipActive && currentSubscription &&
                                    <div className={s.subscriptionBtnTooltip}>
                                        <div className={s.row}>
                                            <span className={s.title}>{t('start_date')}:</span>
                                            <span>{convertDate(subscriptionStartDate, 'DMY')}</span>
                                        </div>
                                        <div className={s.row}>
                                            <span className={s.title}>{t('end_date')}:</span>
                                            <span>{convertDate(subscriptionEndDate, 'DMY')}</span>
                                        </div>
                                    </div>
                                }
                                <button
                                    onClick={() => {
                                        if (user_role === OWNER) {
                                            navigate('/subscriptions')
                                        }
                                    }}
                                    onMouseEnter={() => setSubscriptionTooltipActive(true)}
                                    onMouseLeave={() => setSubscriptionTooltipActive(false)}
                                    className={`${s.defaultButton} ${
                                        subscriptionEndDateCount < 2
                                            ? s.red
                                            : subscriptionEndDateCount >= 1 && subscriptionEndDateCount < 4
                                                ? s.orange
                                                : ''
                                    }`}
                                    style={{
                                        backgroundImage: `url(${
                                            fetchSubscriptionsPending
                                                ? subscriptionsDisabledRedBG
                                                : subscriptionBgImage || subscriptionsDisabledRedBG
                                        })`,
                                        cursor: user_role === OWNER ? 'pointer' : 'default'
                                    }}
                                >
                                    {/*<div className={s.subscriptionBtnTooltip}>*/}
                                    {/*    <div className={s.row}>*/}
                                    {/*        <span className={s.title}>{t('start_date')}:</span>*/}
                                    {/*        <span>{convertDate(subscriptionStartDate, 'DMY')}</span>*/}
                                    {/*    </div>*/}
                                    {/*    <div className={s.row}>*/}
                                    {/*        <span className={s.title}>{t('end_date')}:</span>*/}
                                    {/*        <span>{convertDate(subscriptionEndDate, 'DMY')}</span>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    {/*<div className={s.subscriptionExpirationTooltip}>fasfasfas</div>*/}
                                    {/*isSubscriptionToolipActive*/}
                                    <SvgSelector id='crown-icon'/>

                                    <span className={s.text}>
                              {fetchSubscriptionsPending
                                  ? t('loading')
                                  : subscriptionName
                                      ? (
                                          <>
                                              {subscriptionName}
                                              {/*<span*/}
                                              {/*    className={s.daysCount}*/}
                                              {/*>*/}
                                              {/*    {subscriptionEndDateCount + " " + t('days')}*/}
                                              {/*</span>*/}
                                          </>
                                      )
                                      : t('subscription_inactive')}
                            </span>
                                </button>
                            </div>
                        }

                        <button
                            className={s.menuBtn}
                            onClick={() => dispatch(setAdaptiveMenu(!isAdaptiveMenuActive))}
                        >
                            <SvgSelector id="burger-menu"/>
                        </button>
                    </div>
                </div>

                {
                    (isSearch || isButton || isLink) && <div className={s.changingElements}>
                        {
                            isSearch && <Search value={searchValue} setValue={setSearchValue}/>
                        }

                        {
                            isLink && <Link to={linkPath} className={s.primaryBtn}>
                                {isCreateButton && <SvgSelector id="plus-button"/>}
                                {buttonText}
                            </Link>
                        }

                        {
                            isButton && <button
                                className={`${s.primaryBtn} ${!isCreateButton ? s.default : ""}`}
                                onClick={buttonHandler}
                                disabled={isButtonPending}
                            >
                                {isCreateButton && <SvgSelector id="plus-button"/>}
                                {buttonText}
                            </button>
                        }
                    </div>
                }
            </div>
        </div>
    )
}

export default Header;